$shm_hitalama_domain_page $mol_book2
	tools /
		<= Status $giper_baza_status
	placeholders /
	pages /
		<= Settings $mol_page
			body /
				<= Baza_url $mol_string
					value? <=> baza_url? \
				<= Online $mol_check_box
					title \Online
					checked? <=> online? false
				<= Online_agent $mol_check_box
					title \Online agent
					checked? <=> online_agent? false
				<= Domain_grab $mol_button_minor
					click? <=> domain_grab? null
				\Domain_link:
				<= Domain_link $mol_string
					value? <=> domain_link? \
				<= Domain_can_change $mol_view
					sub /
						\domain_can_change:
						<= domain_can_change \false
				<= Profiles_grab $mol_button_minor
					click? <=> profiles_grab? null
				<= Templates_js_reset $mol_button_minor
					title \Сбросить templates_js
					click? <=> templates_js_reset? null
				<= Templates_tsx_reset $mol_button_minor
					title \Сбросить templates_tsx
					click? <=> templates_tsx_reset? null
				<= Templates_sql_reset $mol_button_minor
					title \Сбросить templates_sql
					click? <=> templates_sql_reset? null
				<= Templates_commands_reset $mol_button_minor
					title \Сбросить templates_commands
					click? <=> templates_commands_reset? null
				\Profiles_link:
				<= Profiles_link $mol_text
					text <= profiles_link \
				<= Profiles_can_change $mol_view
					sub /
						\profiles_can_change:
						<= profiles_can_change \false
				<= Profiles $mol_textarea
					value <= profile_keys \
				<= Hidden_reg $mol_link
					arg *
						section \registerkey
				<= Current_map_section $mol_view
					sub /
						\Current map:
						<= Current_map_link $mol_text
							text <= current_map_link \
						<= Current_map_version $mol_view
							sub /
								\version:
								<= current_map_version \-
						<= Current_map_latest_version $mol_view
							sub /
								\latest:
								<= current_map_latest_version \-
						<= Current_map_reupdate $mol_button_minor
							title \reupdate
							click? <=> current_map_reupdate? null
				\overlayed_map_id:
				<= Overlayed_map_id $mol_string
					value? <=> overlayed_map_id? \
				<= Overlayed_map_enabled $mol_check_box
					title \Overlayed_map_enabled
					checked? <=> overlayed_map_enabled? false
				<= Running_fiber_visible $mol_check_box
					title \running_fiber_visible
					checked? <=> running_fiber_visible? false
		^ Current_map_widgets3_visible / <= Current_map_widgets3 $shm_hitalama_map_book_widgets3
			map <= current_map $shm_hitalama_map
			Map_page <= Current_map_widgets3_map_page $shm_hitalama_map_page
